import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createDepartmentSuccess } from 'src/app/pages/add-department/state/add-department.actions';
import { createExtensionSuccess } from 'src/app/pages/add-extension/state/add-extension.actions';
import {
   deleteDepartmentSuccess,
   modifyDepartmentSuccess,
} from 'src/app/pages/department-details/state/department-detail.actions';
import { saveExtensionDetailSuccess } from 'src/app/pages/extension-details/state/extension-detail.actions';
import { DepartmentOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { filterDepartmentOption } from '../../select/shared/filter-department-option';
import { departmentOptionActions } from './department-option.actions';

export const departmentOptionFeatureKey = 'departmentOptions';

export type DepartmentOptionState = EagerSelectState<DepartmentOption>;

const adapter = createEagerSelectAdapter<DepartmentOptionState, DepartmentOption>({
   featureKey: departmentOptionFeatureKey,
   selectId: (department: DepartmentOption) => {
      return department.departmentId;
   },
});

export const departmentOptionSelectors = adapter.getSelectors(filterDepartmentOption);

const initialState = adapter.getInitialState();

export const departmentOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   departmentOptionActions.search,
   departmentOptionActions.searchReset,
   departmentOptionActions.loadFromApi,
   departmentOptionActions.loadFromApiSuccess,
   departmentOptionActions.loadFromApiFailure,
   null,
   on(
      modifyDepartmentSuccess,
      createDepartmentSuccess,
      createExtensionSuccess,
      saveExtensionDetailSuccess,
      deleteDepartmentSuccess,
      (state) => {
         return {
            ...state,
            callState: LoadingState.Init,
         };
      }
   )
);
